<div class="d-flex flex-row-fluid w-100" [style.background-image]="'url(./assets/img/' + 'userprofile-bg.jpg)'"
     style="height: 400px; background-size: cover; background-position: left 27%; border-radius: .4rem">
  <div class="d-flex align-items-center text-center flex-column justify-content-center h-100 w-100"
       style="position: relative;">
    <div class="overflow-hidden text-left" style="height: 100%;width: 100%;top: 0;position: absolute;">
      <div *ngFor="let icon of icons" [ngStyle]="icon.pos" class="icon-container">
        <sb-icon style="font-size: x-large; color: white" [icon]="icon.name"></sb-icon>
      </div>
    </div>

    <div style="position: absolute;top: 120px;display: flex; align-items: center">
      <div class="image-video-wrapper">
        <div class="userPic cursor-pointer"
             [style.backgroundImage]="avatarUrl?'url('+avatarUrl+')':''">
          <div class="userPicEdit"
               *ngPermissions="[permissionService.Permission.company_show, permissionService.Permission.company_edit]"
               (click)="pickProfileImage()">
            <sb-icon class="icon-center" icon="edit"></sb-icon>
          </div>
        </div>
      </div>
      <div class="ml-4">
        <h2 style="color: #fdfeff;text-shadow: 0 0 10px #000;" class="font-weight-bolder">
          {{ client?.name }}
        </h2>
      </div>
    </div>
  </div>
</div>

<div class="px-0 px-sm-0 px-md-2 px-lg-4 px-xl-5 px-xxl-10 px-xxxl-10" style="margin-top: -100px">
  <div class="row">
    <div class="col-lg-3">
      <sb-card>
        <div card-body>
          <ul class="nav-tabs nav sidenav">
            <li class="nav-item">
              <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="RoutingID.clientOverview"
                 [sbRouterLink]="RoutingID.clientOverview">
                <span>
                  <sb-icon class="mr-3" icon="eye"></sb-icon>
                  {{ 'lang.globals.overview' | translate }}
                </span>
              </a>
            </li>
            <li class="nav-item" *ngPermissions="permissionService.Permission.client_user_list">
              <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="RoutingID.clientUserManagement"
                 [sbRouterLink]="RoutingID.clientUserManagement">
                <span>
                  <sb-icon class="mr-3" icon="userManagement"></sb-icon>
                  {{ 'lang.globals.userManagement' | translate }}
                </span>
              </a>
            </li>
            <li class="nav-item" *ngPermissions="[permissionService.Permission.client_admin, permissionService.Permission.role_list]">
              <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="RoutingID.clientRoleManagement"
                 [sbRouterLink]="RoutingID.clientRoleManagement">
                <span>
                  <sb-icon class="mr-3" icon="userRoles"></sb-icon>
                  {{ 'lang.globals.roleManagement' | translate }}
                </span>
              </a>
            </li>
            <li class="nav-item" *ngPermissions="permissionService.Permission.client_admin">
              <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="RoutingID.clientConnections"
                 [sbRouterLink]="RoutingID.clientConnections">
                <span>
                  <sb-icon class="mr-3" icon="company"></sb-icon>
                  {{ 'lang.globals.connectedClients' | translate }}
                </span>
              </a>
            </li>
            <li class="nav-item !tw-pl-6 " *ngPermissions="permissionService.Permission.client_admin">
              <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="RoutingID.clientInvitations"
                 [sbRouterLink]="RoutingID.clientInvitations">
                <span>
                  <sb-icon class="mr-3" icon="link"></sb-icon>
                  {{ 'lang.globals.invitations' | translate }}
                </span>
              </a>
            </li>
            <li class="nav-item" *ngPermissions="permissionService.Permission.client_admin">
              <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="RoutingID.clientApiKeys"
                 [sbRouterLink]="RoutingID.clientApiKeys">
                <span>
                  <sb-icon class="mr-3" icon="password"></sb-icon>
                  {{ 'lang.globals.apiKeys' | translate }}
                </span>
              </a>
            </li>
            <li class="nav-item" *ngPermissions="permissionService.Permission.client_setting_list">
              <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="RoutingID.clientSettings"
                 [sbRouterLink]="RoutingID.clientSettings">
                <span>
                  <sb-icon class="mr-3" icon="setting"></sb-icon>
                  {{ 'lang.globals.settings' | translate }}
                </span>
              </a>
            </li>
          </ul>
        </div>
      </sb-card>
    </div>
    <div class="col-lg-9">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
